// 平台类型
type TrackEventType = 'cnzz' | 'clklog' | 'all'
// 定义打点类别，增加 tabClick 和 videoPlayDuration
type TrackEventCategory =
  | 'advertise'
  | 'videoClick'
  | 'videoCollect'
  | 'videoShare'
  | 'videoPlay'
  | 'searchClick'
  | 'tabClick'
  | 'videoPlayDuration'
  | 'appDownload'
  | 'app'
  | 'PageClose'
  | 'DomainVisit'
  | 'RegisterClick'
  | 'LoginClick'
  | 'MenuClick'
  | 'FeedbackClick'
  | 'TabStay'
  | 'TagClick'
  | 'ChannelClick'
  | 'LineClick'
  | 'LoginWithKey'
  | 'ConditionClick'
  | 'Logout'
// 定义打点参数接口
interface TrackEventOptions {
  type?: TrackEventType // 打点类型：cnzz、clklog 或 all（默认）
  category: TrackEventCategory // 打点类别
  id?: any // 广告或视频的 ID 或搜索词
  name?: string // 广告或视频的名称或其他信息
  searchContent?: string // 站内搜索内容（仅在 category 为 searchClick 时使用）
  advertiseType?: string | number // 广告类型名称
  tabId?: string // Tab ID
  tabName?: string // Tab 名称
  appDownload?: string // app下载
  playId?: string // 视频播放唯一 ID
  topicId?: string // 视频主题
  channelId?: string // 视频频道
  video_quality?: string //视频清晰度
  videoTopic?: string // 视频主题
  videoChannel?: string // 视频频道
  tagId?: string // 标签id
  duration?: number // 事件时长
  userId?: string // 用户id
  condition_id?: string // 条件id
}

const trackEvent = ({
  type = 'all',
  category,
  id = '',
  name = 'a-a',
  searchContent = '',
  advertiseType = '',
  tabId = '',
  tabName = '',
  playId = '',
  topicId = '',
  channelId = '',
  video_quality = '',
  tagId = '',
  duration = 0,
  userId = '',
  condition_id = '',
  load_success = 1
}: TrackEventOptions) => {
  // const appInfo = appAgentParams()

  const win: any = window

  // cnzz 广告点击打点统计
  const trackCnzzAdvertise = () => {
    if (win.czc) {
      win.czc.push(['_trackEvent', 'advertise', 'click', id])
    }
  }

  // cnzz 视频点击打点统计
  const trackCnzzVideo = () => {
    if (win.czc) {
      win.czc.push(['_trackEvent', 'video', 'play', id])
    }
  }
  // cnzz 登录打点统计
  const trackCnzzLogin = () => {
    if (win.sensors) {
      win.sensors.loginWithKey('user_key', userId)
    }
  }
  // 条件筛选点击
  const trackCnzzFilterClick = () => {
    if (win.sensors) {
      win.sensors.track('ConditionClick', {
        condition_id: condition_id
      })
    }
  }

  //app下载统计
  const trackClklogAppDownLoadClick = () => {
    if (win.sensors) {
      win.sensors.track('AppDownload', {
        os_name: '',
        origin_host: window.location.origin
      })
    }
  }

  // clklog 广告点击打点统计
  const trackClklogAdvertise = () => {
    if (win.sensors) {
      win.sensors.track('AdvertiseClick', {
        advertise_id: id,
        advertise_name: name,
        origin_host: window.location.origin,
        advertise_type: advertiseType, // 广告类型字段
        load_success //0:加载失败 ； 1:加载成功
      })
    }
  }
  // //登录
  // sensors.loginWithKey('user_key','100001')
  // clklog 注册点击

  //注册点击
  const trackClklogRegisterClick = () => {
    if (win.sensors) {
      win.sensors.track('RegisterClick', {
        origin_host: window.location.origin
      })
    }
  }
  // 登录点击
  const trackClklogLoginClick = () => {
    if (win.sensors) {
      win.sensors.track('LoginClick', {
        origin_host: window.location.origin
      })
    }
  }
  //侧边栏按钮点击
  const trackClklogSideMenuClick = () => {
    if (win.sensors) {
      win.sensors.track('MenuClick', {
        origin_host: window.location.origin
      })
    }
  }
  // tab 停留时长打点
  const trackClklogTabStay = () => {
    if (win.sensors) {
      win.sensors.track('TabStay', {
        tab_id: tabId,
        event_duration: duration,
        origin_host: window.location.origin
      })
    }
  }

  //反馈点击
  const trackClklogFeedbackClick = () => {
    if (win.sensors) {
      win.sensors.track('FeedbackClick', {
        video_id: id,
        origin_host: window.location.origin
      })
    }
  }
  // clklog tab 点击打点统计
  const trackClklogTabClick = () => {
    if (win.sensors) {
      win.sensors.track('TabClick', {
        tab_id: tabId,
        tab_name: tabName,
        origin_host: window.location.origin
      })
    }
  }

  // 标签点击
  const trackClklogTopicClick = () => {
    if (win.sensors) {
      win.sensors.track('TagClick', {
        video_id: id,
        tag_id: tagId //标签id
      })
    }
  }

  // 线路点击
  const trackClklogLineClick = () => {
    if (win.sensors) {
      win.sensors.track('LineClick', {
        video_id: id
      })
    }
  }
  // clklog 视频播放时长打点统计
  const trackClklogVideoPlayDuration = () => {
    if (win.sensors) {
      win.sensors.track('VideoPlayDuration', {
        play_id: playId,
        video_id: id,
        video_name: name,
        video_topic: topicId ? topicId : 0,
        video_channel: channelId ? channelId : 0,
        origin_host: window.location.origin,
        video_quality: video_quality ? video_quality : 700
      })
    }
  }
  // clklog 关闭页面
  const trackClklogVideoClosePage = () => {
    if (win.sensors) {
      win.sensors.track('page_close', {
        event_time: new Date().toISOString(),
        url: window.location.href,
        user_agent: navigator.userAgent
      })
    }
  } // clklog 域名统计
  const trackClklogDomainVisit = () => {
    if (win.sensors) {
      win.sensors.track('DomainVisit', {
        event_time: new Date().toISOString(),
        url: window.location.href,
        user_agent: navigator.userAgent,
        domain_url: window.location.origin
      })
    }
  }

  // clklog 视频点击（跳转到视频播放页）打点统计
  const trackClklogVideoClick = () => {
    if (win.sensors) {
      win.sensors.track('VideoClick', {
        video_id: id,
        video_name: name,
        origin_host: window.location.origin,
        video_topic: topicId ? topicId : 0,
        video_channel: channelId ? channelId : 0
      })
    }
  }

  // clklog 视频收藏打点统计
  const trackClklogVideoCollect = () => {
    if (win.sensors) {
      win.sensors.track('VideoCollect', {
        video_id: id,
        video_name: name,
        origin_host: window.location.origin
      })
    }
  }

  // clklog 视频分享打点统计
  const trackClklogVideoShare = () => {
    if (win.sensors) {
      win.sensors.track('VideoShare', {
        video_id: id,
        video_name: name,
        origin_host: window.location.origin
      })
    }
  }

  // clklog 视频播放打点统计
  const trackClklogVideoPlay = () => {
    if (win.sensors) {
      win.sensors.track('VideoPlay', {
        video_id: id,
        video_name: name,
        advertise_type: advertiseType, // 广告类型字段
        origin_host: window.location.origin
      })
    }
  }

  // clklog 搜索打点统计
  const trackClklogSearchClick = () => {
    if (win.sensors && searchContent) {
      win.sensors.track('SearchClick', {
        search_content: searchContent,
        origin_host: window.location.origin
      })
    }
  }

  // 频道点击
  const trackClklogChannelClick = () => {
    if (win.sensors) {
      win.sensors.track('ChannelClick', {
        video_channel: channelId
      })
    }
  }

  // 根据传入的类别执行对应的打点（CNZZ）
  const trackCnzz = () => {
    if (category === 'advertise') {
      trackCnzzAdvertise()
    } else if (category === 'videoClick') {
      trackCnzzVideo()
    } else {
      // console.warn('CNZZ 不支持此类别的打点:', category)
    }
  }

  // 退出登录
  const trackCnzzLogout = () => {
    if (win.sensors) {
      win.sensors.logout()
    }
  }
  // 根据传入的类别执行对应的打点（Clklog）
  const trackClklog = () => {
    if (category === 'advertise') {
      trackClklogAdvertise()
    } else if (category === 'videoClick') {
      trackClklogVideoClick()
    } else if (category === 'videoCollect') {
      trackClklogVideoCollect()
    } else if (category === 'videoShare') {
      trackClklogVideoShare()
    } else if (category === 'videoPlay') {
      trackClklogVideoPlay()
    } else if (category === 'searchClick') {
      trackClklogSearchClick()
    } else if (category === 'appDownload') {
      trackClklogAppDownLoadClick() // 新增 tab 点击打点
    } else if (category === 'app') {
      trackClklogTabClick() // 新增 tab 点击打点
      trackClklogSearchClick()
    } else if (category === 'tabClick') {
      trackClklogTabClick() // 新增 tab 点击打点
    } else if (category === 'videoPlayDuration') {
      trackClklogVideoPlayDuration() // 新增视频播放时长打点
    } else if (category === 'ChannelClick') {
      trackClklogChannelClick()
    } else if (category === 'PageClose') {
      trackClklogVideoClosePage() // 新增关闭页面打点
    } else if (category === 'DomainVisit') {
      trackClklogDomainVisit() // 域名统计
    } else if (category === 'RegisterClick') {
      trackClklogRegisterClick() // 注册点击
    } else if (category === 'LoginClick') {
      trackClklogLoginClick() // 登录点击
    } else if (category === 'LoginWithKey') {
      trackCnzzLogin() // 登录点击
    } else if (category === 'ConditionClick') {
      trackCnzzFilterClick() // 条件筛选点击
    } else if (category === 'MenuClick') {
      trackClklogSideMenuClick() // 侧边栏按钮点击
    } else if (category === 'FeedbackClick') {
      trackClklogFeedbackClick() // 反馈点击
    } else if (category === 'TabStay') {
      trackClklogTabStay()
    } else if (category === 'TagClick') {
      trackClklogTopicClick()
    } else if (category === 'LineClick') {
      trackClklogLineClick()
    } else if (category === 'Logout') {
      trackCnzzLogout() // 退出登录
    } else {
      console.warn('未知的打点类别:', category)
    }
  }

  // 根据传入的类型进行不同的打点
  if (type === 'cnzz') {
    // 仅执行 CNZZ 打点
    trackCnzz()
  } else if (type === 'clklog') {
    // 仅执行 Clklog 打点
    trackClklog()
  } else if (type === 'all' || !type) {
    // 同时执行 CNZZ 和 Clklog 打点
    trackCnzz()
    trackClklog()
  } else {
    // 如果传入了未知的类型，输出警告信息
    console.warn('未知的打点类型:', type)
  }
}

export default trackEvent

// 示例用法

// // 使用 cnzz 广告点击打点
// trackEvent({ type: 'cnzz', category: 'advertise', id: '广告id' });
//
// // 使用 clklog 广告点击打点
// trackEvent({ type: 'clklog', category: 'advertise', id: '广告id', name: '广告名称' });
//
// // 同时进行 cnzz 和 clklog 的广告点击打点
// trackEvent({ category: 'advertise', id: '广告id', name: '广告名称' });
//
// // 使用搜索打点
// trackEvent({ category: 'searchClick', searchContent: '搜索内容' });
//
// // 使用 clklog 视频点击（跳转到视频播放页）打点
// trackEvent({ type: 'clklog', category: 'videoClick', id: '视频id', name: '视频名称' });
//
// // 使用 clklog 视频收藏打点
// trackEvent({ type: 'clklog', category: 'videoCollect', id: '视频id', name: '视频名称' });
//
// // 使用 clklog 视频分享打点
// trackEvent({ type: 'clklog', category: 'videoShare', id: '视频id', name: '视频名称' });
//
// // 使用 clklog 视频播放打点
// trackEvent({ type: 'clklog', category: 'videoPlay', id: '视频id', name: '视频名称' });
//
//
// // 使用 Clklog 广告点击打点（包含广告类型）
// trackEvent({ type: 'clklog', category: 'advertise', id: 'ad_123', name: '广告名称', advertiseType: '横幅广告' });
//
// // 使用 Clklog tab 点击打点
// trackEvent({ type: 'clklog', category: 'tabClick', tabId: 'tab_1', tabName: '首页' });
//
// // 使用 Clklog 视频播放时长打点 瀑布流传0
// trackEvent({ type: 'clklog', category: 'videoPlayDuration', playId: 'play_123', id: 'video_123', name: '视频名称', topicId: '0', channelId: '111' });

// 域名统计
// trackEvent({ type: 'clklog', category: 'DomainVisit' });

// 设置唯一id,设备号；
// sensors.identify('id_xx1')
// 登录用户ID
// sensors.login('id_xx1');
// 自定义公共属性
// sensors.bind('user_id','100001')
// 自定义公共属性
// sensors.registerPage({
//   current_url: location.href,
//   referrer: document.referrer
// });
